import React, {useEffect, useState} from "react";
import queryString from "query-string";
import axios from "../../axios/Instances/axios-instance";
import {Link} from "react-router-dom";

const ConfirmMobile = (props) => {

    const [result, setResult] = useState('');

    const confirmationToken = (props.location.search) ? queryString.parse(props.location.search).c : null;

    const mobilePhone = (props.location.search) ? queryString.parse(props.location.search).mp : null;

    useEffect(() => {

        const json = {
            "mobile_phone": mobilePhone,
            "confirmation_token": confirmationToken
        }

        axios.post("api/plugin/v1/account/mobile/enable", json).then((response) => {
                if (response.status === 200)
                    setResult('SUCCESS');
            }
        ).catch((error) => {
            if (error.response.data.message.includes('bereits bestätigt'))
                setResult('IS_ALREADY_ACTIVE');
            if (error.response.data.message.includes('falsch'))
                setResult('WRONG_CODE');
        });
    }, [confirmationToken, mobilePhone]);

    if (result === '') return <div></div>;
    if (result === 'SUCCESS') return <div className="text-center">Vielen Dank, Ihre Mobilfunknummer wurde
        bestätigt.<br/><Link to={"smcia17092020://smartmeeting.online/login"}>Zurück zur App</Link></div>
    if (result === 'IS_ALREADY_ACTIVE') return <div className="text-center">Vielen Dank, Ihre Mobilfunknummer wurde
        bereits bestätigt. <br/><Link to={"smcia17092020://smartmeeting.online/login"}>Zurück zur App</Link></div>
    if (result === 'WRONG_CODE') return <div className="text-center">Der Bestätigungscode ist falsch.</div>

}

export default ConfirmMobile;
